// @flow

import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import Loadable from 'react-loadable'

import { BrowserRouter } from 'react-router-dom'

import Routes from './Routes/routes'
import * as serviceWorker from './serviceWorker'
class App extends Component<{}, {loaded: boolean}> {
  constructor (props) {
    super(props)
    this.state = { loaded: false }
  }

  async componentDidMount () {
    this.setState({
      loaded: true
    })
  }

  render () {
    const { loaded } = this.state
    if (!loaded) {
      return <div>Loading...</div>
    }
    return (
      <BrowserRouter>
        <Routes data={window.__REACT_STATE__} />
      </BrowserRouter>
    )
  }
}

const root = document.getElementById('root')

if (root !== null) {
  if (root.hasChildNodes() === true) {
    Loadable.preloadReady().then(() => {
      ReactDOM.hydrate(<App />, root)
    })
  } else {
    ReactDOM.render(<App />, root)
  }
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
